import enMessages from '../../messages/en-messages.json';
import zhMessages from '../../messages/zh-messages.json';
import esMessages from '../../messages/es-messages.json';
import frMessages from '../../messages/fr-messages.json';
import deMessages from '../../messages/de-messages.json';

// eslint-disable-next-line no-script-url
export const disallowedKeywords = ['script', 'eval', 'javascript:', 'onload', '%3Cscript', '&#x3Cscript', '%253Cscript', 'javascript'];

export const LOCALE_MESSAGE = {
  'en-US': {
    ...enMessages
  },
  'en-GB': {
    ...enMessages
  }, // TODO : Prepare UK english file
  'zh-CN': {
    ...zhMessages
  },
  'es-ES': {
    ...esMessages
  },
  'fr-FR': {
    ...frMessages
  },
  'de-DE': {
    ...deMessages
  }
};
